import { FloatingBlock } from './block/Block/FloatingBlock'
import { FixedBlock } from './block/Block/FixedBlock'

// let usedIds = new Set()
const alpha = 'ABCDEFGHJKLMNPRSTUVWXYZ'.split('')
export const uniqueId = () => {
  return Array(4)
    .fill(0)
    .map(x => Math.random() < 0.5 ? alpha[~~(Math.random() * 23)] : ~~(Math.random() * 10))
    .join('')
}

export const makeBlock = (block) => block.type === 'floating' ? new FloatingBlock(block) : new FixedBlock(block)

export const ucfirst = (str) => str.charAt(0).toUpperCase() + str.slice(1)
